module.exports = __webpack_public_path__ + "static/media/7.Honda Power Sprayer.e5c4ee1e.jpg";